import request from '@/utils/request'

export function payOrder (data) {
    return request({
        url: 'pay/wechatPay',
        method: 'GET',
        params: data
    })
}